export const setNonprofitIdParam = (value: string) => {
  if (value) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('nonprofitId', value);
    window.history.replaceState(null, '', currentUrl.toString());
  }
};

export const clearNonprofitIdParam = () => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('nonprofitId');
  window.history.replaceState(null, '', currentUrl.toString());
};

export const setStepParam = (value: string) => {
  if (value) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('step', value);
    window.history.replaceState(null, '', currentUrl.toString());
  }
};

export const clearStepParam = () => {
  // @TODO-DP: that's a hack to make it run after `setStepParam` called in `onTransition`
  setTimeout(() => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('step');
    window.history.replaceState(null, '', currentUrl.toString());
  });
};
